import React from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useMutation } from 'react-query';
import axios from 'api/request';
import { endPoints } from 'api/endpoints';
import { orderPayload, validVSForm, selectedVSService, toggleQuickConfig } from 'pages/provisioning/virtual-service/store';

const useAksKeyvaultDetails = () => {
    const [order, setOrder] = useRecoilState(orderPayload);
    const validForm = useRecoilValue(validVSForm);
    const selectedVS = useRecoilValue(selectedVSService);
    const isOpen = useRecoilValue(toggleQuickConfig);
    const aksKeyvaultDetailsApi = useMutation((aksName) => axios.get(`${endPoints.virtualService.aksKeyvaultDetails(aksName)}`));

    const hasCustomDomainSelected = order?.aksVirtualService?.some((item, index) =>
        isOpen && index === selectedVS ? false : item?.customDomainSelected === 'Yes'
    );
    const isUpdate = order?.aksVirtualServiceRequestType === 'UPDATE' && validForm?.isNamespaceExists;
    const isCreateWithCustomDomain = order?.aksVirtualServiceRequestType === 'CREATE' && hasCustomDomainSelected;
    const shouldFetch = order?.aksCluster && (isUpdate || isCreateWithCustomDomain);

    const resetKeyvaultFields = () => ({
        keyVaultName: '',
        spcName: '',
        keyVaultRegion: '',
    });

    React.useEffect(() => {
        setOrder((prevOrder) => ({ ...prevOrder, ...resetKeyvaultFields() }));
    }, [validForm?.isNamespaceExists?.toString(), order?.aksVirtualServiceRequestType, hasCustomDomainSelected]);

    React.useEffect(() => {
        const fetchKeyvaultDetails = async () => {
            if (!shouldFetch) return;
            try {
                const response = await aksKeyvaultDetailsApi.mutateAsync(order.aksCluster);
                setOrder((prevOrder) => ({
                    ...prevOrder,
                    keyVaultName: response?.data?.keyVaultName || '',
                    spcName: response?.data?.spcName || '',
                    keyVaultRegion: response?.data?.keyVaultRegion || '',
                }));
            } catch {
                setOrder((prevOrder) => ({ ...prevOrder, ...resetKeyvaultFields() }));
            }
        };
        fetchKeyvaultDetails();
    }, [order?.aksCluster, order?.aksVirtualServiceRequestType, validForm?.isNamespaceExists, hasCustomDomainSelected]);
};

export default useAksKeyvaultDetails;
